export default "__VITE_ASSET__ChhsYgBx__"